import { ref } from 'vue'

export interface LogEntry {
  timestamp: string
  component: string
  event: string
  data?: any
  level: 'info' | 'warn' | 'error' | 'debug'
}

export class Logger {
  private logs = ref<LogEntry[]>([])
  private maxLogs = 1000

  private createLogEntry(component: string, event: string, data?: any, level: LogEntry['level'] = 'info'): LogEntry {
    return {
      timestamp: new Date().toISOString(),
      component,
      event,
      data,
      level
    }
  }

  log(component: string, event: string, data?: any) {
    const entry = this.createLogEntry(component, event, data, 'info')
    this.logs.value.push(entry)

    // Keep only the last maxLogs entries
    if (this.logs.value.length > this.maxLogs) {
      this.logs.value = this.logs.value.slice(-this.maxLogs)
    }

    // Transport-specific logging will be handled by transport composables
  }

  warn(component: string, event: string, data?: any) {
    const entry = this.createLogEntry(component, event, data, 'warn')
    this.logs.value.push(entry)
  }

  error(component: string, event: string, data?: any) {
    const entry = this.createLogEntry(component, event, data, 'error')
    this.logs.value.push(entry)
  }

  debug(component: string, event: string, data?: any) {
    const entry = this.createLogEntry(component, event, data, 'debug')
    this.logs.value.push(entry)
  }

  getLogs() {
    return this.logs.value
  }

  clearLogs() {
    this.logs.value = []
  }

  getLogsByComponent(component: string) {
    return this.logs.value.filter(log => log.component === component)
  }

  getLogsByLevel(level: LogEntry['level']) {
    return this.logs.value.filter(log => log.level === level)
  }
}
